import { RouterModule, Routes } from '@angular/router';

import { AccessibilityGuard } from 'src/app/auth/accessibility.guard';
import { AuthGuardService } from './../../../auth/auth-guard.service';
import { CommonModule } from '@angular/common';
import { JobOrderComponent } from './job-order.component';
import {NgModule} from '@angular/core';
import { SharedModule } from 'src/app/template/shared/shared.module';
import { NgScrollbarModule } from 'ngx-scrollbar';

const routes: Routes = [{
    path: '',
    children: [
        {
            path: '',
            component: JobOrderComponent,
            canActivate: [AuthGuardService], data: { breadcrumb: 'Add' }
            },
          {
            path: 'edit/:id',
            component: JobOrderComponent,
            canActivate: [AuthGuardService], data: { breadcrumb: 'Edit' }
          }
    ]
}];


@NgModule({
    imports: [
    CommonModule,
        RouterModule.forChild(routes),
        SharedModule,
        NgScrollbarModule
    ],
    declarations: [
        JobOrderComponent,
    ],
    providers: []
})

export class JobOrderModule {}